import(/* webpackMode: "eager" */ "/hisea-ssr/src/app/(app)/medical-professional-discounts/loading.js");
